import './styles.scss';

interface ModalDescriptionProps {
	description: string;
	alingment?: 'center' | 'left';
}
export const ModalDescription: React.FC<ModalDescriptionProps> = ({ description, alingment = 'center' }: ModalDescriptionProps) => (
	<div className={`modalDescription modalDescription--${alingment}`}>{description}</div>
);

export default ModalDescription;
